module.exports = __webpack_public_path__ + "img/page2-bg.e0551035.png";